import React, { useState, useCallback } from 'react';
import { withTranslation } from '../../../ChildrenContext.js';
import PropTypes from 'prop-types';
import CustomNotify from '../../../Notify';
import Button from '../../../Button';
import FormGroup from '../../../FormGroup';
import Icon from "../../../Icon";

const images = {
    eye: require('img/icons/icon-eye.svg'),
    eyeSlash: require('img/icons/icon-eye-slash.svg'),
};

const SecurityPassword = ({
    loading: initialLoading,
    errors: initialErrors,
    changePassword,
    t
}) => {
    const [state, setState] = useState({
        loading: initialLoading || false,
        errors: initialErrors || {},
        curPassword: '',
        newPassword: '',
        confirmationPassword: '',
        typePassword: 'password'
    });

    const onSubmit = useCallback((event) => {
        event.preventDefault();

        setState(prevState => ({
            ...prevState,
            loading: true
        }));

        if (changePassword) {
            changePassword(state, onSuccess, onError);
        }
    }, [state, changePassword]);

    const onSuccess = useCallback(() => {
        let staticNames = t?.notyMessages || {};
        let staticNamesSecurity = t?.securityPage?.changePassword || {};

        setState(prevState => ({
            ...prevState,
            loading: false,
            curPassword: '',
            newPassword: '',
            confirmationPassword: ''
        }));

        CustomNotify(staticNamesSecurity.passwordChanged || staticNames.update || 'Password changed successfully');
    }, [t]);

    const onError = useCallback((errors) => {
        setState(prevState => ({
            ...prevState,
            errors: errors || {},
            loading: false
        }));
    }, []);

    const onChange = useCallback((event) => {
        const name = event.target.name;
        const value = event.target.value;

        if (name === 'confirmationPassword') {
            if (value !== state.newPassword) {
                // add error
                setState(prevState => ({
                    ...prevState,
                    errors: {
                        ...prevState.errors,
                        new_password: ["The entered passwords don't match"]
                    }
                }));
            } else {
                // remove error
                const newErrors = { ...state.errors };
                if (typeof(newErrors.new_password) !== "undefined") {
                    delete newErrors.new_password;
                }
                setState(prevState => ({
                    ...prevState,
                    errors: newErrors
                }));
            }
        }

        setState(prevState => ({
            ...prevState,
            [name]: value
        }));
    }, [state.newPassword, state.errors]);

    const resetPassword = useCallback(() => {
        setState(prevState => ({
            ...prevState,
            curPassword: '',
            confirmationPassword: '',
            newPassword: '',
        }));
    }, []);

    const toggleShowPassword = useCallback((event) => {
        let icon = event.target;
        let input = event.target.closest('.password-container').querySelector('input');

        icon.classList.toggle('eye');
        icon.classList.toggle('eye-slash');
        if(input.getAttribute('type') === 'password') {
            input.setAttribute('type', 'text');
        } else {
            input.setAttribute('type', 'password');
        }
    }, []);

    const staticNames = t?.securityPage?.changePassword || {};
    const staticNamesActions = t?.actions || {};

    return (
        <form className="form-password form" onSubmit={onSubmit}>
            <div className="form-body">
                <FormGroup
                    label={`${staticNames.currentPassword}:`}
                    labelClass="control-label"
                    fieldClass="password-container"
                    errors={state.errors.current_password}
                >
                    <input
                        className="form-control short-imput"
                        type={state.typePassword}
                        name={'curPassword'}
                        value={state.curPassword}
                        required
                        onChange={onChange}
                    />
                    <span className="password-icon eye" onClick={toggleShowPassword}></span>
                </FormGroup>
                <FormGroup
                    label={`${staticNames.password}:`}
                    labelClass="control-label"
                    fieldClass="password-container"
                    errors={state.errors.new_password}
                >
                    <input
                        className="form-control short-input"
                        type="password"
                        name={'newPassword'}
                        value={state.newPassword}
                        required
                        onChange={onChange}
                    />
                    <span className="password-icon eye" onClick={toggleShowPassword}></span>
                </FormGroup>
                <FormGroup
                    label={`${staticNames.passwordConfirmation}:`}
                    labelClass="control-label"
                    fieldClass="password-container"
                    errors={state.errors.new_password_confirmation}
                >
                    <input
                        className="form-control short-input"
                        type="password"
                        name={'confirmationPassword'}
                        value={state.confirmationPassword}
                        required
                        onChange={onChange}
                    />
                    <span className="password-icon eye" onClick={toggleShowPassword}></span>
                </FormGroup>
            </div>
            <div className="form-footer">
                <FormGroup fieldClass="save-form">
                    <Button
                        type={'button'}
                        text={staticNamesActions.cancel}
                        extraClass={{ 'cancel-btn': true }}
                        onClick={resetPassword}
                    />
                    <Button
                        type={'submit'}
                        text={staticNamesActions.save}
                        extraClass={{ 'apply-btn': true }}
                    />
                </FormGroup>
            </div>
        </form>
    );
};

SecurityPassword.propTypes = {
    loading: PropTypes.bool,
    errors: PropTypes.object,
    changePassword: PropTypes.func,
    t: PropTypes.object
};

SecurityPassword.defaultProps = {
    loading: false,
    errors: {},
    changePassword: () => {},
    t: {}
};

export default withTranslation(SecurityPassword);
